import { JwtTokenData } from '@/models/token.model';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class JwtService {
  decodeToken(token: string): JwtTokenData | null {
    if (token) {
      const [, payload] = token.split('.');
      if (payload) {
        const tokenData = JSON.parse(window.atob(payload)) as JwtTokenData;
        return tokenData;
      }
    }

    return null;
  }

  isTokenExpired(token: string): boolean {
    const decodedToken = this.decodeToken(token);
    if (!decodedToken?.exp) {
      return true;
    }

    if (Date.now() > decodedToken?.exp * 1000) {
      return true;
    }

    return false;
  }
}
